import React, { PureComponent } from 'react';
import PT from 'prop-types';
import { connect } from 'react-redux';
import { Image } from 'semantic-ui-react';
import compareIcon from '../../../../assets/images/compare-icon.svg';
import { selectControlsState } from '../../../../store/reducers/tableControls';
import classes from './ComparePlayer.css';

const mapStateToProps = state => ({
  players: selectControlsState(state).selectedPlayers,
});
const actions = {};
export class ComparePlayer extends PureComponent {
  static propTypes = {
    players: PT.arrayOf(PT.shape({
      player_id: PT.number.isRequired,
      player: PT.string.isRequired,
    })),
    loggedIn: PT.bool.isRequired,
  }

  static defaultProps = {
    players: [],
    loggedIn: false,
  }

  render = () => {
    const { players, loggedIn } = this.props;

    if (players.length < 2 || !loggedIn) return null;

    return (
      <button className={classes.controlButton}>
        <Image inline spaced src={compareIcon} />Compare Player
      </button>
    );
  }
}
export default connect(mapStateToProps, actions)(ComparePlayer);



// WEBPACK FOOTER //
// ./src/app/components/TableControls/ComparePlayer/ComparePlayer.js